module.exports = __webpack_public_path__ + "img/eu_svt_logo_2.14f37b81.png";